export {bootstrap} from './core/bootstrap';


/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/dali.js
 **/